<div mat-dialog-content>
	<color-picker [(value)]="color"></color-picker>
</div>
<div mat-dialog-actions>
	<button mat-button [mat-dialog-close]="null">Cancel</button>
	<button mat-button [mat-dialog-close]="color">Save</button>
</div>
